import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_ACTIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanActionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTIONS:
        return payload || state;

      case LOAN_ACTIONS_ACTION_TYPE.EDIT_LOAN_ACTION:
      case LOAN_ACTIONS_ACTION_TYPE.CREATE_LOAN_ACTION:
        draft[payload.criteriaId] = {
          ...payload,
        };
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanActionsReducer;
